import { DateTime } from "luxon";

/**
 * Combine separate date and time DateTime objects into a single datetime
 * @param {string} type - The prefix for the date/time fields (e.g., 'start', 'end')
 * @param {Object} state - The state object containing the date and time fields
 * @returns {DateTime|undefined} Combined datetime or undefined if date or time is missing
 */
export const getDateTime = (type, state) => {
  const toDateTime = (value) => {
    if (value instanceof DateTime) return value;
    if (value instanceof Date) return DateTime.fromJSDate(value);
    if (typeof value === 'string') return DateTime.fromISO(value);
    return null;
  };

  const date = toDateTime(state[type + "Date"]);
  const time = toDateTime(state[type + "Time"]);

  if (!date?.isValid || !time?.isValid) {
    return undefined;
  }

  // Combine date and time components, preserving the timezone from the date
  return date.set({
    hour: time.hour,
    minute: time.minute,
    second: 0,
    millisecond: 0,
  });
};
